import { newToolFilterOAuthMcp } from "../oauth.ts";

export const mypromindMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.mypromind.com/favicon.ico",
  url: "https://www.mypromind.com/interface/mcp",
  label: "mypromind.com",
});
